import type { ReactNode } from 'react'

/**
 * Kicker above a section heading: Georgia italic in sentence case
 * (`.vc2-kicker`, vc2.css). Accent by default (forest in light, brass-bright
 * in dark); a caller's `className` replaces the default, so a caller that
 * passes one supplies its own colour too. On a forest band use
 * `text-vc2-on-forest`, never `text-vc2-paper` (paper turns forest-dark in
 * dark, near-invisible on the forest band).
 */
export function Eyebrow({ children, className = 'text-vc2-accent' }: { children: ReactNode; className?: string }) {
  return <p className={`vc2-kicker ${className}`.trim()}>{children}</p>
}
